import * as React from 'react';
import { typeOfComponent } from '../typeOfComponent';
export var processTypes = function (types) { return types.map(function (x) {
    switch (typeof x) {
        case 'string':
            return x;
        case 'function':
            return typeOfComponent(React.createElement(x));
        case 'object':
        default: {
            var component = React.createElement(x);
            var type = typeOfComponent(component);
            if (type === 'react.forward_ref') {
                return typeOfComponent(component.type.render(component.props, component.ref));
            }
            return typeOfComponent(x);
        }
    }
}); };
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export var toChildrenArray = function (children) { return Array.isArray(children) ? children : React.Children.toArray(children); };
